import type { ReactNode } from "react";
import { Illustration, type IllustrationName } from "./Illustration";

export interface EmptyStateProps {
  title: ReactNode;
  children?: ReactNode;
  illustration?: IllustrationName;
  action?: ReactNode;
  compact?: boolean;
}

/** Leerer Zustand: Illustration, ein Satz, was hier erscheinen wird, und eine Aktion. */
export function EmptyState({ title, children, illustration, action, compact }: EmptyStateProps) {
  return (
    <div className={["rg-empty", compact && "rg-empty--compact"].filter(Boolean).join(" ")}>
      {illustration ? <Illustration name={illustration} size={compact ? 80 : 120} /> : null}
      <div className="rg-empty__title">{title}</div>
      {children ? <div className="rg-empty__text">{children}</div> : null}
      {action ? <div className="rg-empty__action">{action}</div> : null}
    </div>
  );
}
